import {defineNuxtPlugin} from "#app";
import {googleTrackPageView} from "~/utils/google-track";


export default defineNuxtPlugin(async (nuxtApp) => {
  const router = useRouter()
  const route = useRoute()
  let lastPath = ''

  // google 埋点，pageView
  googleTrackPageView(route.name, route.fullPath)

  router.afterEach((to, from) => {
    if (to.path === from.path || to.fullPath === lastPath) return
    lastPath = to.fullPath
    // google 埋点，pageView
    googleTrackPageView(to.name, to.fullPath)

    // 路由跳转时，统一关闭弹窗
    document.body.style.overflowY = "auto"
  })
})
